import { render } from "./opciones.vue?vue&type=template&id=c942e09a&scoped=true"
import script from "./opciones.vue?vue&type=script&lang=js"
export * from "./opciones.vue?vue&type=script&lang=js"

import "./opciones.vue?vue&type=style&index=0&id=c942e09a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c942e09a"]])

export default __exports__